import React from 'react';

function StatsCards({ data }) {
  if (!data || data.totalSessions === 0) {
    return (
      <div className="empty-state">
        <h3>No Data Available</h3>
        <p>Start collecting data by adding the collector script to your pages.</p>
      </div>
    );
  }

  const totalBids = data.winRates?.bidders?.reduce((sum, b) => sum + b.totalBids, 0) || 0;
  const overallWinRate = data.winRates?.bidders?.length > 0
    ? (data.winRates.bidders.reduce((sum, b) => sum + b.wins, 0) / Math.max(totalBids, 1) * 100).toFixed(1)
    : '0';

  return (
    <div className="stats-grid">
      <div className="stat-card">
        <div className="label">Total Sessions</div>
        <div className="value">{data.totalSessions?.toLocaleString()}</div>
      </div>
      <div className="stat-card">
        <div className="label">Total Bid Responses</div>
        <div className="value">{totalBids.toLocaleString()}</div>
      </div>
      <div className="stat-card success">
        <div className="label">Overall Win Rate</div>
        <div className="value">{overallWinRate}%</div>
      </div>
      <div className="stat-card success">
        <div className="label">Est. Revenue (CPM)</div>
        <div className="value">${data.winRates?.totalRevenue?.toFixed(2) || '0.00'}</div>
      </div>
      <div className="stat-card critical">
        <div className="label">Est. Leakage</div>
        <div className="value">${data.revenueLeakage?.totalEstimatedLeakage?.toFixed(2) || '0.00'}</div>
      </div>
    </div>
  );
}

export default StatsCards;
